import { createRoute, redirect } from '@tanstack/react-router';

import { BaseRouteLayout } from '$/routes/Layouts/BaseRouteLayout';
import { queryClient } from '$/services/client';
import { inspirationQuery } from '$/services/usecases/inspirations/queries';
import { harmonyByIdQuery } from '$/services/usecases/materials/queries';

export const DesignGuideHarmonyRoute = createRoute({
  getParentRoute: () => BaseRouteLayout,
  path: '/designguide/$harmonyId',
  beforeLoad: async ({ params }) => {
    const harmony = params.harmonyId
      ? await queryClient.ensureQueryData(harmonyByIdQuery(params.harmonyId))
      : undefined;
    if (!harmony) throw redirect({ to: '/designguide', replace: true });

    const inspiration = await queryClient.fetchQuery(
      inspirationQuery(harmony.inspirationId),
    );
    if (!inspiration) throw redirect({ to: '/designguide', replace: true });

    throw redirect({
      to: '/inspirations/$id',
      params: { id: harmony.inspirationId },
      search: { harmonyId: harmony.id },
      replace: true,
    });
  },
});
